import { render, staticRenderFns } from "./notification-view.vue?vue&type=template&id=9ff1f80a"
import script from "./notification-view.vue?vue&type=script&lang=js"
export * from "./notification-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports